import { ChangeDetectionStrategy, Component, output, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CodeInputModule } from 'angular-code-input';

@Component({
  selector: 'app-reset-password-pin-step',
  templateUrl: './reset-password-pin-step.component.html',
  styleUrls: ['./reset-password-pin-step.component.scss'],
  imports: [TranslatePipe, CodeInputModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ResetPasswordPinStepComponent {
  public passwordSubmit = output<string>();

  public passcodeValue = signal({
    passcode: '',
    confirmPasscode: '',
    valid: false,
  });

  public onPasswordChanged(password: string): void {
    this.passcodeValue.update((value) => ({
      ...value,
      passcode: password,
      valid: password.length < 4 ? false : value.valid,
    }));
  }

  public onConfirmPasswordChanged(password: string): void {
    this.passcodeValue.update((value) => ({
      ...value,
      confirmPasscode: password,
      valid: password.length < 4 ? false : value.valid,
    }));
  }

  public onPasswordCompleted(password: string): void {
    this.passcodeValue.update((value) => ({
      ...value,
      passcode: password,
      valid: password === value.confirmPasscode,
    }));
  }

  public onConfirmPasswordCompleted(password: string): void {
    this.passcodeValue.update((value) => ({
      ...value,
      confirmPasscode: password,
      valid: value.passcode === password,
    }));
  }

  public resetPassword(): void {
    this.passwordSubmit.emit(this.passcodeValue().passcode);
  }
}
